import analyticsTrack from '../../lib/analytics/analyticsTrack';

export default function handleNavigationClick(linkTitle: string, prefix: string = '') {
  return () => {
    analyticsTrack('nav_clicked', {
      linkname: `${prefix}${linkTitle}`,
    });
  };
}
